import { Link } from "@inertiajs/react";
import {
  AppBar,
  Box,
  Container,
  Link as MuiLink,
  Toolbar,
} from "@mui/material";

import logo from "../../assets/Logo.svg";

const Navigation = () => (
  <AppBar position="relative" sx={{ boxShadow: "none" }}>
    <Toolbar disableGutters>
      <Container
        maxWidth="lg"
        sx={{
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          height: { xs: undefined, sm: "5.5em" },
          marginBottom: { xs: "0.5em", sm: 0 },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: "0.5em", sm: "2em" },
        }}
      >
        <Box
          sx={{
            minWidth: 0,
            "& a": {
              color: "white",
              textDecoration: "none",
              textTransform: "uppercase",
            },
          }}
        >
          <Link href="/">
            <Box
              alt="Solidaritijd logo"
              component="img"
              src={logo}
              sx={{
                marginTop: { xs: "0.5em", sm: 0 },
                height: { xs: "3em", sm: "4.5em" },
                color: "white",
                maxWidth: "100%",
              }}
            />
          </Link>
        </Box>
        <Box
          sx={{ display: "flex", gap: { xs: "1em", sm: "3em" }, flexShrink: 0 }}
        >
          <MuiLink
            color="white"
            component={Link}
            fontSize={21}
            fontWeight={700}
            href="/over"
            underline="hover"
          >
            Hoe werkt het?
          </MuiLink>
          <MuiLink
            color="white"
            component={Link}
            fontSize={21}
            fontWeight={700}
            href="/contact"
            underline="hover"
          >
            Contact
          </MuiLink>
        </Box>
      </Container>
    </Toolbar>
  </AppBar>
);

export default Navigation;
